function numberFormat(nStr, inD = '.', outD = '.', sep = ',') {
    nStr += '';
    let dpos = nStr.indexOf(inD);
    let nStrEnd = '';
    if (dpos !== -1) {
        nStrEnd = outD + nStr.substring(dpos + 1, nStr.length);
        nStr = nStr.substring(0, dpos);
    }
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(nStr)) {
        nStr = nStr.replace(rgx, `$1${sep}$2`);
    }
    return nStr + nStrEnd;
}
export default numberFormat;
